import React, { useEffect } from 'react';

export default function FullScreenModal(props) {
    useEffect(() => {
        if (!document.body.classList.contains('xs_fullScreenModal')) {
            document.body.classList.add('xs_fullScreenModal');
            if (props.isBetslip) {
                document.body.classList.add('xs_betslipOpen');
            }
            return () => {
                document.body.classList.remove('xs_fullScreenModal');
                if (props.isBetslip) {
                    document.body.classList.remove('xs_betslipOpen');
                }
            }
        }
    }, []);

    return (
        <>
            {props.children}
        </>
    );
}
